/* eslint-disable */
/*******************************************************************************
 * KindEditor - WYSIWYG HTML Editor for Internet
 * Copyright (C) 2006-2011 kindsoft.net
 *
 * @author Roddy <luolonghao@gmail.com>
 * @site http://www.kindsoft.net/
 * @licence http://www.kindsoft.net/license.php
 *******************************************************************************/
import axios from 'axios'
import store from '@/vuex/store'

import {
  Message
} from "element-ui";

KindEditor.plugin('image', function (K) {
  //debugger
  // console.log(window.e_id)
  var self = this,
    name = 'image',
    uploadJson = K.undef(self.uploadJson, self.basePath + 'php/upload_json.php'),
    imageTabIndex = K.undef(self.imageTabIndex, 0),
    imgPath = self.pluginsPath + 'image/images/',
    extraParams = K.undef(self.extraFileUploadParams, {}),
    filePostName = K.undef(self.filePostName, 'imgFile'),
    fillDescAfterUploadImage = K.undef(self.fillDescAfterUploadImage, false),
    lang = self.lang(name + '.');
  // console.log('123', 'kingeditor_K' + (parseInt(window.e_id)))
  if (window.e_id) {
    window['kingeditor_K' + (parseInt(window.e_id) + 1)] = function (data) {
      self.plugin.image.edit(data)
    };
  } else {
    // console.log(window.e_id)
    window['kingeditor_K' + 1] = function (data) {
      self.plugin.image.edit(data)
    };
  }
  window.rich_text_add_img = function (url, fileName='') {
    self.plugin.image.edit([{
      width: '100%',
      height: 'static',
      path: url,
      fileName:fileName
    }])
  }
  // window[kingeditor_K + '_id']
  self.plugin.imageDialog = function (options) {
    var imageUrl = options.imageUrl,
      imageWidth = K.undef(options.imageWidth, ''),
      imageHeight = K.undef(options.imageHeight, ''),
      imageTitle = K.undef(options.imageTitle, ''),
      imageAlign = K.undef(options.imageAlign, ''),
      showRemote = K.undef(options.showRemote, true),
      showLocal = K.undef(options.showLocal, true),
      tabIndex = K.undef(options.tabIndex, 0),
      clickFn = options.clickFn;
    var target = 'kindeditor_upload_iframe_' + new Date().getTime();
    var hiddenElements = [];
    for (var k in extraParams) {
      hiddenElements.push('<input type="hidden" name="' + k + '" value="' + extraParams[k] + '" />');
    }
    var html = [
      '<div style="padding:20px;">',
      //size
      '<div class="ke-dialog-row">',
      '<label for="remoteWidth" style="width:60px;">' + lang.size + '</label>',
      lang.width +
      ' <input type="text" id="remoteWidth" class="ke-input-text ke-input-number" name="width" value="" maxlength="4" /> ',
      lang.height +
      ' <input type="text" class="ke-input-text ke-input-number" name="height" value="" maxlength="4" /> ',
      '</div>',
      //align
      '<div class="ke-dialog-row"  style="display:none">',
      '<label style="width:60px;">' + lang.align + '</label>',
      '<input type="radio" name="align" class="ke-inline-block" value="" checked="checked" />',
      ' <input type="radio" name="align" class="ke-inline-block" value="left" /> ',
      ' <input type="radio" name="align" class="ke-inline-block" value="right" /> ',
      '</div>',
      //alt
      '<div class="ke-dialog-row">',
      '<label for="remoteTitle" style="width:60px;">Alt</label>',
      '<input type="text" id="remoteTitle" class="ke-input-text" name="title" value="" style="width:200px;" maxlength="200" />',
      '</div>',
      '</div>',
      //remote image - end
      '</div>'
    ].join('');
    var dialogWidth = 450,
      dialogHeight = 200;
    var dialog = self.createDialog({
        name: name,
        width: dialogWidth,
        height: dialogHeight,
        title: self.lang(name),
        body: html,
        yesBtn: {
          name: self.lang('yes'),
          click: function (e) {
            // Bugfix: http://code.google.com/p/kindeditor/issues/detail?id=319
            if (dialog.isLoading) {
              return;
            }
            // insert remote image
            var width = widthBox.val(),
              height = heightBox.val(),
              title = titleBox.val(),
              align = '';
            console.log(width, height)
            alignBox.each(function () {
              if (this.checked) {
                align = this.value;
                return false;
              }
            });
            if (!/^\d*$/.test(width)) {
              alert(self.lang('invalidWidth'));
              widthBox[0].focus();
              return;
            }
            if (!/^\d*$/.test(height)) {
              alert(self.lang('invalidHeight'));
              heightBox[0].focus();
              return;
            }
            clickFn.call(self, '', title, width, height, 0, align);
          }
        },
        beforeRemove: function () {
          widthBox.unbind();
          heightBox.unbind();
          refreshBtn.unbind();
        }
      }),
      div = dialog.div;

    var widthBox = K('.ke-dialog-row[name="width"]', div),
      heightBox = K('.ke-dialog-row[name="height"]', div),
      refreshBtn = K('.ke-refresh-btn', div),
      titleBox = K('.ke-dialog-row [name="title"]', div),
      alignBox = K('.ke-dialog-row [name="align"]', div);

    var originalWidth = 0,
      originalHeight = 0;

    function setSize(width, height) {
      widthBox.val(width);
      heightBox.val(height);
      originalWidth = width;
      originalHeight = height;
    }

    widthBox.change(function (e) {
      if (originalWidth > 0) {
        heightBox.val(Math.round(originalHeight / originalWidth * parseInt(this.value, 10)));
      }
    });
    heightBox.change(function (e) {
      if (originalHeight > 0) {
        widthBox.val(Math.round(originalWidth / originalHeight * parseInt(this.value, 10)));
      }
    });
    setSize(options.imageWidth, options.imageHeight);
    titleBox.val(options.imageTitle);
    alignBox.each(function () {
      if (this.value === options.imageAlign) {
        this.checked = true;
        return false;
      }
    });
    return dialog;
  };
  self.plugin.image = {
    edit: function (data) {
      var img = self.plugin.getSelectedImage();
      if (img && !store.state.image_upload.showTag) {
        self.plugin.imageDialog({
          imageUrl: img ? img.attr('data-ke-src') : 'http://',
          imageWidth: img ? img.width() : '',
          imageHeight: img ? img.height() : '',
          imageTitle: img ? img.attr('alt') : '',
          imageAlign: img ? img.attr('align') : '',
          clickFn: function (url, title, width, height, border, align) {
            if (img) {
              img.attr('src', img.attr('data-ke-src'));
              img.attr('data-ke-src', img.attr('data-ke-src'));
              img.attr('width', width);
              // img.attr('height', height);
              img.attr('alt', title);
            } else {
              self.exec('insertimage', img.attr('data-ke-src'), title, width, height, border, align);
            }
            // Bugfix: [Firefox] 上传图片后，总是出现正在加载的样式，需要延迟执行hideDialog
            setTimeout(function () {
              self.hideDialog().focus();
            }, 0);
          }
        });
      } else {
        let datalist = data ? data : [];
        for (let i = 0; i < datalist.length; i++) {
          var url = datalist[i].path;
          if (url) {
            url = K.formatUrl(url, 'absolute');
            var title = datalist[i].fileName;
            var border = datalist[i].border;
            var img = self.plugin.getSelectedImage();
            if (img) {
              img.attr('src', url);
              img.attr('data-ke-src', url);
              img.attr('width', datalist[i].width);
              img.attr('height', datalist[i].height);
              img.attr('title', title);
              img.attr('align', 'center');
              img.attr('alt', title);
            } else {
              self.exec('insertimage', url, title, datalist[i].width, datalist[i].height, datalist[i].border,
                'center');
            }
            // Bugfix: [Firefox] 上传图片后，总是出现正在加载的样式，需要延迟执行hideDialog
            setTimeout(function () {
              self.hideDialog().focus();
            }, 0);
          }
        }
      }


    },
    'delete': function () {
      var target = self.plugin.getSelectedImage();
      if (target.parent().name == 'a') {
        target = target.parent();
      }
      target.remove();
      // [IE] 删除图片后立即点击图片按钮出错
      self.addBookmark();
    }
  };
  self.clickToolbar(name, self.plugin.image.edit);
});



// WEBPACK FOOTER //
// ./src/components/my_rich_text/image.js